import type { CardTypeT } from '../../Card.h'

import {
  CARDS_ASPECT_RATIO,
  CardType,
  VOD_CARD_HOVER_SCALE,
} from '../../Card.h'

export const getCardASpectRatio = (type: CardTypeT) => {
  const config = {
    [CardType.HORIZONTAL]: CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
    [CardType.VERTICAL]: CARDS_ASPECT_RATIO.VERTICAL_DEFAULT,
  }

  return config[type]
}

export const getTransformScale = (type: CardTypeT) => {
  const config = {
    [CardType.HORIZONTAL]: VOD_CARD_HOVER_SCALE.HORIZONTAL_CARD,
    [CardType.VERTICAL]: VOD_CARD_HOVER_SCALE.VERTICAL_CARD,
  }

  return config[type]
}
